export const NAMES = {
  TAG_NAME: "ab-tabs",
}
